export default "__VITE_ASSET__BVuoNcaL__"